import styles from './select.module.css'

import { SelectVariantEnum, SelectSizeEnum } from './select.type'

export const sizes: Record<SelectSizeEnum, string> = {
  small: styles['size-small'],
  medium: styles['size-medium'],
  large: styles['size-large'],
}

export const variants: Record<SelectVariantEnum, string> = {
  primary: styles['variant-primary'],
  info: styles['variant-info'],
  danger: styles['variant-danger'],
}

export const generateClasses = (
  isEmpty: boolean,
  size: keyof typeof SelectSizeEnum,
  error?: boolean,
  variant?: keyof typeof SelectVariantEnum,
) => {
  const variantClass = variant ? variants[error ? 'danger' : variant] : ''

  return `${styles.core} ${sizes[size]} ${isEmpty ? styles.placeholder : ''} ${variantClass}`
}
